import { observable, action } from 'mobx';
import Papa from 'papaparse';
import { Updater } from './updater';
import localforage from 'localforage';

const matchingKeys = {
	'ga:date': {
		naver: '일별',
		naver_en: 'Day',
		facebook: '일',
	},
	'ga:impressions': {
		naver: '노출수',
		naver_en: 'Impressions',
		facebook: '노출',
	},
	'ga:adClicks': {
		naver: '클릭수',
		naver_en: 'Clicks',
		facebook: '클릭(전체)',
	},
	'ga:adCost': {
		naver: '총비용(VAT포함,원)',
		naver_en: 'Sum (VAT included, KRW)',
		facebook: '지출 금액 (KRW)',
	},
	'ga:campaign': {
		naver: '캠페인',
		naver_en: 'Campagin',
		facebook: '캠페인 이름',
	},
	'ga:keyword': {
		naver: '키워드',
		naver_en: 'Keyword',
		facebook: '키워드',
	},
	'ga:adContent': {
		naver: '광고그룹',
		naver_en: 'Ad group',
		facebook: '광고 세트 이름',
	},
};
interface IAppliedScheme {
	startDate: number;
	endDate: number;
	errors: string[];
	result: string;
}
export const READY = 'ready';
export const PROCESSING = 'processing';
export const DONE = 'done';

class IStore extends Updater {
	@observable
	public enabled: boolean = true;

	@observable
	public showSelectPlatform: boolean = false;

	@observable
	public schema: any = {
		naver:
			'ga:date,ga:medium,ga:source,ga:impressions,ga:adClicks,ga:adCost,ga:campaign,ga:keyword,ga:adContent',
		naver_en:
			'ga:date,ga:medium,ga:source,ga:impressions,ga:adClicks,ga:adCost,ga:campaign,ga:keyword,ga:adContent',
		facebook:
			'ga:date,ga:medium,ga:source,ga:impressions,ga:adClicks,ga:adCost,ga:campaign,ga:adContent',
	};

	@observable
	public source = ''; // naver or facebook

	@observable
	public status: string = READY;

	@observable
	public startDate: string = '';

	@observable
	public endDate: string = '';

	@observable
	public errors: string[] = [];

	// @observable
	// public history: any = {
	// 	naver: [],
	// 	facebook: [],
	// };

	public input: string = '';
	public result: string = '';
	public fileNames: string[] = [];

	constructor() {
		super();
		switch (location.hostname) {
			case 'localhost':
			case 'dev.tyle.io':
			case 'test.tyle.io':
			case 'tyle.io':
				break;
			default:
			// alert('정상적인 방법으로 이용하십시오.');
			// this.enabled = false;
		}
		// localforage.getItem('history', (err, value: string) => {
		// 	if (value !== null) {
		// 		this.history = JSON.parse(value);
		// 	}
		// });
		localforage.getItem('default_schema', (err, value: string) => {
			if (value !== null) {
				const restoredSchema = JSON.parse(value);
				Object.keys(restoredSchema).forEach((k) => {
					this.schema[k] = restoredSchema[k];
				});
			}
		});
	}

	public getDefaultValue = (key: string): string => {
		const defaultValue = {
			'ga:medium': 'cpc',
			'ga:source': this.source,
			'ga:campaign': `${this.source}_cpc`,
		};
		return defaultValue[key];
	};

	@action
	public addHistory = (downloadName: string): void => {
		// const target = this.history[this.source];
		// if (target.length > 0 && target[target.length - 1] === downloadName) {
		// 	return undefined;
		// }
		// target.push(downloadName);
		// if (target > 20) {
		// 	target.pop(20, 9999);
		// }
		// localforage.setItem('history', JSON.stringify(this.history));
	};

	@action
	public reset = (): void => {
		this.status = READY;
		this.source = '';
		this.input = '';
		this.result = '';
		this.showSelectPlatform = false;
		this.fileNames = [];
	};

	@action
	public addJob = (fileName, csvChunk: string): void => {
		this.fileNames.push(fileName);
		this.input += '\n' + csvChunk;
	};

	@action
	public startConvert = (): void => {
		console.log('startConvert!');
		if (this.source === '') {
			// 자동선택인 경우, 업로드된 모든 파일명을 검사하자
			let commonName: string = '';
			let orgName: string = '';
			this.fileNames.some((v) => {
				console.log('v', v);
				const firstName = encodeURIComponent(v).substr(0, 54);
				if (commonName === '') {
					commonName = firstName;
					orgName = v;
				} else if (commonName !== firstName) {
					commonName = '';
					return true;
				}
			});
			console.log('commonName', commonName);
			console.log('orgName', orgName);
			if (
				commonName ===
					'%E1%84%8E%E1%85%AE%E1%84%8E%E1%85%AE%E1%86%AF%E1%84%8B' ||
				commonName ===
					'%EC%B6%94%EC%B6%9C%EC%9A%A9-%EC%9D%BC%EB%B3%84%EB%B3%B' ||
				orgName.indexOf('추출용') > -1
			) {
				this.source = 'facebook';
			} else if (
				commonName ===
					'%ED%82%A4%EC%9B%8C%EB%93%9C%EB%B3%B4%EA%B3%A0%EC%84%9C' ||
				commonName ===
					'%E1%84%8F%E1%85%B5%E1%84%8B%E1%85%AF%E1%84%83%E1%85%B3' ||
				orgName.indexOf('키워드보고서') > -1
			) {
				this.source = 'naver';
			} else {
				this.showSelectPlatform = true;
				return undefined;
			}
			setTimeout(() => {
				this.startConvert();
			}, 100);
			return undefined;
		}

		this.status = PROCESSING;
		const rows = this.parseInput(this.input);
		if (this.source === 'naver') {
			// 파일명은 같은데 네이버 영문 버전으로 출력된 경우가 있어서 검사
			const header = rows[0].join('|') + rows[1].join('|');
			if (header.indexOf('총비용(VAT포함,원)') === -1) {
				this.source = 'naver_en';
			}
		}
		const { startDate, endDate, errors, result } = this.generateResult(
			rows
		);
		this.startDate = startDate.toString();
		this.endDate = endDate.toString();
		this.errors = errors;
		this.result = result;
		setTimeout(() => {
			this.status = DONE;
		}, 1000);
	};

	@action
	public updateSchema = (e): void => {
		this.schema[this.source] = e.target.value;
		localforage.setItem('default_schema', JSON.stringify(this.schema));
	};

	public generateResult = (rows: any): IAppliedScheme => {
		return this.applyToScheme(
			this.schema[this.source],
			this.refineRows(rows)
		);
	};

	public parseInput = (input: string): any[] => {
		return Papa.parse(input)
			.data.filter((row) => row.length > 1)
			.map((row) => row.map((col) => col.trim()));
	};

	public refineRows = (rows: any[]): any[] => {
		const requiredColumn = matchingKeys['ga:date'][this.source];
		const columns = rows.find((row) => row.indexOf(requiredColumn) > -1);
		return rows
			.filter((row) => {
				return row.indexOf(requiredColumn) === -1 && row[0] !== '';
			})
			.map((row) => {
				const obj = {};
				row.forEach((value: string, i: number) => {
					if (this.source === 'naver') {
						value = value.replace('_en', '');
					}
					obj[columns[i]] = value;
				});
				return obj;
			});
	};

	public applyToScheme = (
		schema: string,
		refinedRows: any[]
	): IAppliedScheme => {
		console.log('this.source', this.source);
		console.log('this.schema', this.schema);

		const { source, getDefaultValue } = this;
		const columns: string[] = schema.split(',');
		let columnKey: string;
		let value: string;
		let intDate: number;
		const errors = [];
		let startDate: number = Infinity;
		let endDate: number = 0;
		const rows: string[] = refinedRows.map((row) => {
			const cols: string[] = [];
			columns.forEach((gaCol) => {
				columnKey =
					(matchingKeys[gaCol] && matchingKeys[gaCol][source]) || 'x';
				value = row[columnKey];
				if (value === undefined) {
					// 비어있는 경우에 기본값 반영
					if (getDefaultValue(gaCol) !== undefined) {
						value = getDefaultValue(gaCol);
					} else {
						errors.push(columnKey);
					}
				} else if (gaCol === 'ga:date') {
					value = value.replace(/[^0-9]/g, '');
					intDate = Number(value);
					if (intDate < startDate) {
						startDate = intDate;
					} else if (intDate > endDate) {
						endDate = intDate;
					}
				} else if (/^[0-9,\.]+$/.test(value)) {
					// 숫자형값
					value = Math.floor(
						Number(value.replace(/[^0-9\.]/, ''))
					).toString();
				} else {
					value = value.replace(/\s?,\s?/, '/'); // 오류방지용 콤마제거
				}
				cols.push(value);
			});
			return cols.join(',');
		});
		rows.unshift(schema);

		return {
			startDate,
			endDate,
			errors,
			result: rows.join('\n'),
		};
	};
}

export default IStore;



// WEBPACK FOOTER //
// ./src/store.ts